import React, { useState } from "react";
import { bool, node, string } from "prop-types";

import Button from "pages/_components/Button";
import MobileOptions from "./components/MobileOptions";
import { resizableRoute as resizableComponent } from "../Resizable";

export const MobileButtons = resizableComponent(({ children, isMobile, image }) => {
    const [toggle, setToggle] = useState(false);

    if (!isMobile) {
        return null;
    }

    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setToggle((prev) => !prev);
    };

    return (
        <div className="toolbar-item commands-mobile">
            <Button
                className="toolbar-btn view-options"
                onClick={handleClick}
                image={image}
                block={false}
                bsStyle="asLink"
            />
            {toggle && (
                <MobileOptions isVisible={toggle} onToggle={setToggle}>
                    {children}
                </MobileOptions>
            )}
        </div>
    );
});

MobileButtons.propTypes = {
    children: node,
    isMobile: bool.isRequired,
    image: string,
};

MobileButtons.defaultProps = {
    children: null,
    image: "images/figma/icon/menu-ios-white.svg",
};

export default MobileButtons;
